<mat-card [class.has-marker]="markerPosition" [ngClass]="markerPosition">
  <mat-card-title>
    <div class="title-wrapper">
      <span [translate]="titleKey"></span>
      <mat-icon *ngIf="dismissable" (click)="closeStep.emit()">close</mat-icon>
    </div>
  </mat-card-title>
  <div *ngIf="dismissable" class="progression">
    <span class="value" [style.flex]="progression"></span>
  </div>
  <mat-card-content [innerHtml]="descriptionKey | translate"></mat-card-content>
  <mat-card-actions>
    <button mat-raised-button (click)="previous.emit()">
      <span [translate]="previousKey"></span>
    </button>
    <button mat-raised-button color="primary" (click)="next.emit()">
      <span [translate]="nextKey"></span>
    </button>
  </mat-card-actions>
</mat-card>
